import React, { useState, useEffect } from "react";
import styles from "./registro.module.css";
import { useDispatch} from "react-redux";
import {  DNIaction } from "../../store/actions.js"; 
import ReactGA from 'react-ga';

import LogoPrincipal from "./assets/LogoPrincipalHome.png";
import LogoConcierto from "./assets/CoollogoConciertos.png";
import Gaseosas from "./assets/Gaseosas.png";
import LogoIsm from "./assets/LogoISM.png";
import GaseosasMobile from "./assets/GaseosasMobile.png";
import LogoISMMobile from "./assets/LogoISMMobile.png";
import Swal from 'sweetalert2';
import axios from "axios";

import Modal from "react-modal";
import "./modal.css";
 
import { Link ,  useNavigate, useLocation} from "react-router-dom"; 
import TerminosYcondiciones from "../../components/terminosYcondiciones/terminosYcondiciones";
import Politicas from "../../components/poltiticas/Politicas";

const Registro2 = () => {
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [color, setcolor] = useState(false);
  const [colorBtn, setcolorBtn] = useState(true);
  const [redireccionar, setRedireccionar] = useState(false);
  const [emailError, setEmailError] = useState(false);
  

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();

  const [datosEnvio, setDatosEnvio] = useState({
    nombre: "",
    apellido: "",
    email: "",
    tel: "",
    Provincia: "",
    DNI: "",
    email: "",
    direccion:"",
    check: false
  });

  const setTerminos = () => {
    setModal(!modal);
  };
  const setTerminos2 = () => {
    setModal2(!modal2);
  };
  const colorCiudad = () => {
    setcolor(true);
  };


  useEffect(() => {

    ReactGA.pageview('/registro');

      document.title = ": Destapa y gana conciertos gratis por un año / Cool Fresh, una marca de ISM";

    // Actualizar la descripción de la página
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Regístrate para destapar y ganar conciertos gratis por un año con Cool Fresh, una marca de ISM");
    }
    // Verificar si todos los campos de datosEnvio están llenos
    if (
      datosEnvio.nombre &&
      datosEnvio.apellido &&
      datosEnvio.DNI &&
      datosEnvio.Provincia &&
      datosEnvio.direccion &&
      datosEnvio.email &&
      datosEnvio.tel &&
      datosEnvio.check !== false
    ) {
      setcolorBtn(false);
    } else {
      setcolorBtn(true);
    }
  }, [datosEnvio]);
  
  const datosCheck = () => {
    setDatosEnvio({
      ...datosEnvio,
      check :  !datosEnvio.check ,
    })
  }

  const handleInputChange = async(e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setDatosEnvio({
      ...datosEnvio,
      [name]: newValue,
    });  
  };


  const handleInputChangeSelect = (e) => {
    const { value } = e.target;
    setDatosEnvio({
      ...datosEnvio,
      Provincia : value,
    });
  };

  const subirData = async (e) => {
    try {

      if(emailError ===  true){
        Swal.fire('¡Error!', 'Escribe un formato de correo valido', 'error');
        return
    }
      


      if(!colorBtn){
        let response = await axios.post(
          "https://winged-rain-production.up.railway.app/users",
          {
            nombre: `${datosEnvio.nombre} ${datosEnvio.apellido}`,   
            email:datosEnvio.email,
            tel: datosEnvio.tel,
            Provincia:datosEnvio.Provincia,
            DNI:datosEnvio.DNI,
            email:datosEnvio.email,
            direccion:datosEnvio.direccion,
          
          }
        );
  
        if(response.data === "ya existe un usuario con este DNI"){
          Swal.fire('¡Error!', 'ya existe un usuario con este DNI', 'error');
          return
      }
        setDatosEnvio({
          nombre: "",
          apellido: "",
          email: "",
          tel: "",
          nombre: "",
          Provincia: "",
          DNI: "",
          email: "",
          direccion:"",
          check:false
        })
        setcolorBtn(true);

        if(response.data){
          dispatch(DNIaction(response.data.DNI))   
          Swal.fire('Felicitaciones', '¡Ya estás registrado!', 'success').then((result) => {
            if (result.isConfirmed) {
              // Redirigir una vez que el usuario haga clic en "OK"
              navigate("/ingresoDNI");
            }
          });
        }
      }

   
    } catch (error) {
      // Manejo de errores
      console.error("Error al enviar los datos:", error);
    }
  };

  function handleInputLetra(event) {
    const inputValue = event.target.value;

    // Utiliza una expresión regular para permitir solo texto (letras)
    const textoValido = inputValue.replace(/[^A-Za-z\s]/g, '');

    // Actualiza el estado con el valor de texto válido
    setDatosEnvio({
      ...datosEnvio,
      nombre: textoValido,
    });  
  }
  
  function handleInputLetraApellido(event) {
    const inputValue = event.target.value;

    // Utiliza una expresión regular para permitir solo texto (letras)
    const textoValido = inputValue.replace(/[^A-Za-z\s]/g, '');

    // Actualiza el estado con el valor de texto válido
    setDatosEnvio({
      ...datosEnvio,
      apellido: textoValido,
    });  
  }


  const handleInputCorreo = (event) => {
    const { name, value } = event.target;

    // Validar si el valor introducido es un correo electrónico válido
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const isValidEmail = emailPattern.test(value);

    // Actualizar el estado del correo y el estado de error
    setDatosEnvio({
      ...datosEnvio,
      email: value,
    });  
    setEmailError(!isValidEmail);
  };

  const handleInputChangeDni = (e) => {
    // Obtén el valor del input
    const inputValue = e.target.value;

    // Verifica si el valor es numérico
    if (!isNaN(inputValue)) {
      // Actualiza el estado solo si es un valor numérico
   
        setDatosEnvio({
          ...datosEnvio,
          DNI: inputValue,
        });  
    
    }
  };


    const handleInputChangeTel = (e) => {
    // Obtén el valor del input
    const inputValue = e.target.value;

    // Verifica si el valor es numérico
    if (!isNaN(inputValue)) {
      // Actualiza el estado solo si es un valor numérico
   
        setDatosEnvio({
          ...datosEnvio,
          tel: inputValue,
        });  
    
    }
  };

  const redirect = async () => {
    try {
        navigate("/");
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <div className={styles.Home}>
      {/* <Link to={"/prueba"}> */}
        <img onClick={redirect} alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoPrincipal}  className={styles.LogoPrincipal}></img>
      {/* </Link> */}
      <form className={styles.form} style={{zIndex:'1'}}>
        <div className={styles.divContenedor}>
          <div className={styles.divInputs}>
            <input
              placeholder="Nombres*"
              name="nombre"
              type="text"
              value={datosEnvio.nombre}
              onChange={handleInputLetra}
            ></input>


            <input
              placeholder="Apellidos*"
              name="apellido"
              type="text"
              value={datosEnvio.apellido}
              onChange={handleInputLetraApellido}
            ></input>

              
          </div>

          <div className={styles.divInputs}>
          <input
              placeholder="DNI o Carnet de extranjería*"
              name="DNI"
              value={datosEnvio.DNI}
              onChange={handleInputChangeDni}
              
            ></input>

            <input
              placeholder="Teléfono*"
              name="tel"
              value={datosEnvio.tel}
              onChange={handleInputChangeTel}
            ></input>

          </div>


          <div className={styles.divInputs}>
          <input
              placeholder="Correo electrónico*"
              name="email"
              value={datosEnvio.email}
              onChange={handleInputCorreo}
            ></input>

            <select
              id="pais"
              placeholder="Ciudad*"
              style={{ color: color ? "#0a0a0a" : "#807777" }}
              className={styles.select}
              onClick={() => { colorCiudad() }}
              onChange={handleInputChangeSelect}
              value={datosEnvio.Provincia}
            >
              
              <option value="Ciudad"  name="ciudad">Ciudad</option>
              <option value="Lima"  name="ciudad">Lima</option>
              <option value="Amazonas"  name="Amazonas">Amazonas</option>
              <option value="Ancash"  name="Ancash">Ancash</option>
              <option value="Apurimac"  name="Apurimac">Apurimac</option>
              <option value="Arequipa"  name="Arequipa">Arequipa</option>
              <option value="Ayacucho"  name="Ayacucho">Ayacucho</option>
              <option value="Cajamarca"  name="Cajamarca">Cajamarca</option>
              <option value="Callao"  name="Callao">Callao</option>
              <option value="Cusco"  name="Cusco">Cusco</option>
              <option value="Huancavelica"  name="Huancavelica">Huancavelica</option>
              <option value="Huanuco"  name="Huanuco">Huanuco</option>
              <option value="Ica"  name="Ica">Ica</option>
              <option value="Junin"  name="Junin">Junin</option>
              <option value="La libertad"  name="La libertad">La libertad</option>
              <option value="Lambayeque"  name="Lambayeque">Lambayeque</option>
              <option value="Loreto"  name="Loreto">Loreto</option>
              <option value="Madre de dios"  name="Madre de dios">Madre de dios</option>
              <option value="Moquegua"  name="Moquegua">Moquegua</option>
              <option value="Pasco"  name="Pasco">Pasco</option>
              <option value="Piura"  name="Piura">Piura</option>
              <option value="Puno"  name="Puno">Puno</option>
              <option value="San martin"  name="San martin">San martin</option>
              <option value="Tacna"  name="Tacna">Tacna</option>
              <option value="Tumbes"  name="Tumbes">Tumbes</option>
              <option value="Ucayali"  name="Ucayali">Ucayali</option>
            </select>
          </div>
        </div>
        <div className={styles.divInputs2}>
          <input
           placeholder="Dirección" 
           name="direccion"
           value={datosEnvio.direccion}
           onChange={handleInputChange}
           className={styles.inputCiudad}
           ></input>
        </div>
      </form>

      <div className={styles.terminos} >
      <input  className={styles.checkIn} type="checkbox" checked={datosEnvio.check} onClick={() => datosCheck()}></input>
        <p>
       
          Acepto los{" "}
          <Link onClick={() => setTerminos()} style={{ color: " #FFFFFF" }}>
            Términos y Condiciones
          </Link>{" "}
          {/* y{" "}
          <Link onClick={() => setTerminos2()} style={{ color: " #FFFFFF" }}>
            Políticas de Uso
          </Link>{" "} */}
          de esta promoción.
        </p>
      </div>

      {/* <Link to={"/ingresoDNI"}> */}
        <button className={styles.button} onClick={
          () => subirData()} 
         style={{
          backgroundColor: !colorBtn ? '' : '#B5B5B5',
        }}
        >CREA TU CUENTA</button>
      {/* </Link>  */}

      <Modal
        isOpen={modal}
        overlayClassName="custom-modal-overlay"
        closeTimeoutMS={2000}
        className={`custom-modal `}
      >
        <TerminosYcondiciones setTerminos={setTerminos}></TerminosYcondiciones>
      </Modal>

      <Modal
        isOpen={modal2}
        overlayClassName="custom-modal-overlay"
        closeTimeoutMS={2000}
        className={`custom-modal `}
      >
        <Politicas setTerminos={setTerminos2}></Politicas>
      </Modal>

      <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoConcierto} className={styles.LogoConcierto}></img>
      <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={Gaseosas} className={styles.Gaseosas}></img>
      <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={GaseosasMobile} className={styles.GaseosasMobile}></img>
      <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoIsm} className={styles.LogoIsm}></img>
      <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoISMMobile} className={styles.LogoISMMobile}></img>
    </div>
  );
};

export default Registro2;
